
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Chrome } from 'vue-color'
import vClickOutside from 'v-click-outside'

@Component<InputColor>({
    components: {
        Chrome,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
})
export default class InputColor extends Vue {
    @Prop(String) public value!: string
    @Prop(String) public label!: string
    @Prop({ type: Boolean, default: false }) public disabled?: boolean

    public isModalOpen = false
    public color: { hex: string } = {
        hex: this.value,
    }

    public onClick() {
        if (this.disabled) {
            return
        }
        if (this.isModalOpen) {
            this.$emit('change', this.color.hex)
        } else {
            this.color = {
                hex: this.value,
            }
        }
        this.$nextTick(() => {
            // required due to v-click-outside firing immediatly and closing modal.
            this.isModalOpen = !this.isModalOpen
        })
    }

    public clickedOutside() {
        if (this.isModalOpen) {
            this.$emit('change', this.color.hex)
            this.isModalOpen = false
        }
    }

    public onInput(value) {
        this.color = value
    }
}
